import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api from "../api"
import { PromoCodeModel } from "../api/promoCode.api"

export interface PromoCodesListState {
    promoCodes: PromoCodeModel[]
    loading: boolean
    error?: string
    // promoCode: {
    // 	name: string;
    // 	country_code: null;
    // 	subscription_duration: string;
    // 	discount_type: string;
    // 	is_coupon_auto: string;
    // 	discount: null;
    // 	start_date: null;
    // 	expiry_date: null;
    // 	code: string;
    // 	user_ids: any[];
    // 	is_open: boolean;
    // 	multiple_count_shipping: string;
    // 	use_count: number;
    // 	subscription_type: string;
    // 	id: number;
    // 	active: boolean;
    // },
    promoCode: Record<string, any>
}

const initialState: PromoCodesListState = {
    promoCodes: [],
    loading: false,
    promoCode: {}
}
export interface addPromoState {
    name: string
    country_code: null
    subscription_duration: string
    discount_type: string
    is_coupon_auto: string
    discount: string
    start_date: string
    expiry_date: string
    code: string
    user_ids: any[]
    is_open: string
    multiple_count_shipping: string
    use_count: string
    subscription_type: string
}

export interface promoByIdState {
    id: string
}

export interface deleteByIdState {
    promocode_id: string
}

export const loadPromoCodes = createAsyncThunk("promoCodes/list", async (thunkAPI) => {
    try {
        const response = await api.promoCode.promoCodesList()

        return response
    } catch (error: any) {
        console.log(error)
    }
})
export const addPromoCodes = createAsyncThunk("promoCodes/add", async (data: addPromoState, thunkAPI) => {
    try {
        const response = await api.promoCode.addPromoCodes(data)

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const editPromoCodes = createAsyncThunk("promoCodes/edit", async (data: addPromoState, thunkAPI) => {
    try {
        const response = await api.promoCode.editPromoCodes(data)

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const loadPromoById = createAsyncThunk("parcels/detail", async (data: promoByIdState, thunkAPI) => {
    try {
        const response = await api.promoCode.PromoById(data)

        if (response.status) {
            return response
        }
    } catch (error: any) {
        console.log(error)
    }
})

export const deletePromoCodes = createAsyncThunk(
    "promoCodes/delete",
    async (data: deleteByIdState, thunkAPI) => {
        try {
            const response = await api.promoCode.deletePromoCodes(data)

            return response
        } catch (error: any) {
            console.log(error)
        }
    }
)

export const promoCodesSlice = createSlice({
    name: "promoCodes",
    initialState,

    reducers: {
        clearError: (state: PromoCodesListState) => {
            state.error = undefined
        }
    },

    extraReducers: {
        [loadPromoCodes.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadPromoCodes.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [loadPromoCodes.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.promoCodes = action.payload?.data?.payload || []
        },

        [addPromoCodes.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [addPromoCodes.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [addPromoCodes.fulfilled.toString()]: (state, action) => {
            state.loading = false
        },

        [loadPromoById.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadPromoById.rejected.toString()]: (state, action) => {
            state.loading = false
            state.error = action.payload?.data?.data?.error || ""
        },
        [loadPromoById.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.promoCode = action.payload?.data?.payload || []
        }
    }
})

export const { clearError } = promoCodesSlice.actions

export default promoCodesSlice.reducer
